var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOperationEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DADF",
    fillRule: "nonzero",
    d: "M45.026 39.623H42.18l-1.008-.973a23.31 23.31 0 0 0 5.655-15.237C46.827 10.482 36.345 0 23.413 0 10.482 0 0 10.482 0 23.413c0 12.932 10.482 23.414 23.413 23.414 5.8 0 11.13-2.125 15.237-5.655l.973 1.008v2.846L57.633 63 63 57.633l-17.974-18.01zm-21.613 0c-8.969 0-16.209-7.24-16.209-16.21 0-8.969 7.24-16.209 16.21-16.209 8.969 0 16.209 7.24 16.209 16.21 0 8.969-7.24 16.209-16.21 16.209zm4.323-19.371l-3.981-5.876A.907.907 0 0 0 23 14a.893.893 0 0 0-.755.385l-3.981 5.867h-4.355c-.5 0-.909.403-.909.896 0 .08.01.16.036.241l2.31 8.303c.209.753.909 1.308 1.745 1.308h11.818c.836 0 1.536-.555 1.755-1.308l2.309-8.303.027-.241a.905.905 0 0 0-.91-.896h-4.354zm-7.463 0L23 16.31l2.727 3.94h-5.454zM23 27.417c-1 0-1.818-.806-1.818-1.791 0-.985.818-1.791 1.818-1.791s1.818.806 1.818 1.79c0 .986-.818 1.792-1.818 1.792z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOperationEmpty);
export default __webpack_public_path__ + "static/media/ic-operation-empty.2ab405d38324d3c9f27cb5599dc7cf4c.svg";
export { ForwardRef as ReactComponent };